import ImmutablePropTypes from 'react-immutable-proptypes'
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { List } from 'immutable'
import { useDispatch } from 'react-redux'
import { ACCESS_PREVIEW } from '../../WatchAccess/index'
import Button, { TYPES } from '../../Button/index'
import Icon, { ICON_TYPES } from '../../Icon.v2/index'
import { H3 } from '../../Heading/index'
import Row from '../../Row.v2/index'
import Tile from '../../Tile/index'
import { getShareV3Link } from '../../../services/share/index'
import { isEntitled } from '../../../services/subscription/index'
import { historyRedirect } from '../../../services/navigation/index'

function handlePlay (onWatch, item) {
  onWatch(item)
}

function createAccessor (Accessor, item) {
  if (!item) return null
  const url = item.get('url', '') || ''
  const title = item.get('title', '')
  return <Accessor title={title} to={url} />
}

function renderItem (item, params, props, onWatch, kind, dispatch) {
  if (!item) return null
  const { auth, staticText } = props
  const isFree = item.get('isFree', false)
  const isSharedAllowed = item.getIn(['feature', 'shareAllowed'], false)
  const isUserEntitled = isEntitled(auth.get('subscriptions', List()))
  const asShare = (isSharedAllowed && !isUserEntitled) || isFree

  return (
    <Tile
      inRow
      auth={auth}
      showMoreInfo={false}
      isFree={isFree}
      tileData={item}
      asShare={asShare}
      staticText={staticText}
      forceAccess={ACCESS_PREVIEW}
      onClickWatch={asShare
        ? () => handlePlay(onWatch, item, kind, dispatch)
        : () => {}}
    />
  )
}

export default function ViewAll (props) {
//
  const {
    modes,
    items,
    kind,
    auth,
    setMode,
    staticText,
    portal,
    language,
    history,
  } = props
  const dispatch = useDispatch()
  const goBack = useCallback(() => {
    setMode(modes.DEFAULT)
  }, [modes, setMode])

  const onCreateFreeVideo = (item) => {
    const url = getShareV3Link({
      userLang: language,
      userRfd: portal.getIn(['data', 'userReferralId']),
      userAffId: portal.getIn(['data', 'everflowAffiliateId']),
      userUid: portal.getIn(['data', 'uuid']),
      contentUrl: item.get('url'),
      contentId: item.get('id'),
      contentType: item.get('contentType'),
    })

    historyRedirect({
      url,
      language,
      history,
      auth,
    })
  }

  return (
    <div className="portal-v2-view-all">
      <Button
        className="portal-v2-view-all__back"
        type={TYPES.GHOST}
        onClick={goBack}
      >
        <Icon type={ICON_TYPES.CHEVRON_LEFT} />
        {staticText.get('back')}
      </Button>
      <section className="portal-v2-view-all">
        <H3>{staticText.get('titleViewAll')}</H3>
        <div className="portal-v2-view-all__divider-line" role="presentation" />
        <Row
          createAccessor={createAccessor}
          items={items}
          auth={auth}
          inverted
          asGrid
        >{(item, data) => renderItem(item, data, props, onCreateFreeVideo, kind, dispatch)}
        </Row>
      </section>
    </div>
  )
}

ViewAll.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  getPortalShare: PropTypes.func.isRequired,
  setMode: PropTypes.func.isRequired,
  modes: PropTypes.object.isRequired,
  kind: PropTypes.string.isRequired,
  items: ImmutablePropTypes.list,
  auth: ImmutablePropTypes.map,
  portal: ImmutablePropTypes.map.isRequired,
  language: PropTypes.string,
  history: PropTypes.object.isRequired,
}
